<template>
  <div class="myProfit" :class="{'isiOSX':isiOSX}">
  	<van-nav-bar
		  title="我的奖品"
		  left-arrow
		  @click-left="reBack"
		/>
    <div class="all">
      <van-tabs sticky scroll="{ scrollTop: 64, isFixed: true }" v-model="active">
        <van-tab title="全部奖品">
        	<profitList :orderStyle="0" :active ="active"/>
        </van-tab>
        <van-tab title="虚拟奖品">
        	<profitList :orderStyle="10"  :active ="active"/>
        </van-tab>
        <van-tab title="实物奖品">
        	<profitList :orderStyle="20"  :active ="active"/>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import profitList from './profitList.vue';
import Bus from "../../providers/eventBus";
export default {
	data() {
    return {
	  isiOSX: false,
	  active:this.$route.query.active || 0
    }
  },
  created(){
    this.isiOSX = this.isIphoneX();
	this.$api.setToken(this.$route.query.token);
	 Bus.$on('busBigTurntableProfit',({tab}) => {
		this.$nextTick(()=>{
			this.active = parseInt(tab);
		 })
		 })
	},

	beforeDestroy(){
    Bus.$off('busBigTurntableProfit')
  },
	components: {
		profitList
	},
	methods: {
		reBack() {
        this.$router.go(-1);
	},

	}
};
</script>
<style scoped>
.myProfit{
	background-color: #ffffff;
	height: 100%;
  overflow-y: hidden;  /* 解决上拉刷新容器会在开始时自身可以滚动 */
}
.van-nav-bar {
	background: rgba(255, 255, 255, 0);
	padding-top: 24px;
	position: fixed;
	top: 0;
	width: 100%;
	background: #fff;
}	
.isiOSX .van-nav-bar{
	padding-top: 44px;
}
.van-nav-bar__title {
  font-size: 18px;
  color: #333;
}
.van-icon-arrow-left:before {
  display: none;
}
.van-nav-bar__left {
  left: 0;
  padding-left: 16px;
}
.van-nav-bar__left .van-icon {
	width: 15px;
	height: 15px;
	display: inline-block;
	background: url(../../assets/myInvest/reback.png) no-repeat center center;
	background-size: 100% 100%;
}
.van-nav-bar__text {
	width: 81px;
	height: 28px;
	line-height: 28px;
	color: #fff;
	font-size: 14px;
	text-align: center;
	background: rgba(29, 30, 31, .2);
	border-top-left-radius: 14px;
	border-bottom-left-radius: 14px;
	padding: 0;
}
.myProfit >>> [class*="van-hairline"]::after {
  border: none;
}
.all {
  padding-top: 108px;
  height: 100%;
  background-color: #ffffff;
}
.isiOSX .all{
	padding-top: 128px;
}
.all .van-tabs{
	min-height: 100%;
}
.all >>> .van-tabs__line {
  background-color: #FF7300;
  height: 2px;
}
.all >>> .van-tab {
  font-size: 16px;
  color: #C0C0C0;
  font-weight: 400;
}
.all >>> .van-tab--active {
  color: #333333;
  font-size: 16px;
  font-weight: 600;
}
.all >>> .van-sticky{
	position: fixed;
	top: 64px;
	width: 100%;
	z-index: 2;
	border-bottom: solid 1px #EEEEEE;
}
.isiOSX .all >>> .van-sticky{
	top: 84px;
}
</style>


